import { Box } from './Box';
import type { ReactElement } from 'react';

export const chartSwatchSizePx = 12;
export const chartSwatchRadiusPx = 2;
export const chartSwatchContainerWidthPx = 20;

type ChartSwatchProps = {
  color: string | undefined;
};

export const ChartSwatch = ({ color }: ChartSwatchProps): ReactElement => (
  <Box
    component="span"
    sx={(theme) => ({
      display: 'inline-block',
      width: chartSwatchSizePx,
      height: chartSwatchSizePx,
      borderRadius:
        typeof theme.shape.borderRadius === 'number'
          ? `${theme.shape.borderRadius / 2}px`
          : chartSwatchRadiusPx,
      backgroundColor: color ?? 'text.secondary',
      flexShrink: 0,
      overflow: 'hidden',
    })}
  />
);
